// extracted by mini-css-extract-plugin
export default {"container":"burger-constructor-total_container__GMo7l","currency":"burger-constructor-total_currency__SGks6"};